import { render, staticRenderFns } from "./SalesCumulatives.vue?vue&type=template&id=bef366d4&"
import script from "./SalesCumulatives.vue?vue&type=script&lang=js&"
export * from "./SalesCumulatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports